import { render, staticRenderFns } from "./DashboardSumut.vue?vue&type=template&id=09415e06&lang=pug"
import script from "./DashboardSumut.vue?vue&type=script&lang=js"
export * from "./DashboardSumut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports